import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {CounselingInductionService} from "../counseling-induction.service";
import {FormArray, FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {MatTable} from "@angular/material/table";
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";

@Component({
  selector: 'app-view-counselling-induction',
  templateUrl: './view-counselling-induction.component.html',
  styleUrls: ['./view-counselling-induction.component.scss']
})
export class ViewCounsellingInductionComponent implements OnInit, OnDestroy {
  private _destroyed$ = new Subject<void>();
  // Add a ViewChild reference to trigger table re-renders
  @ViewChild(MatTable) table!: MatTable<any>;

  inductionId: string | null = null;
  isLoading = true;
  counsellors = new FormControl();
  tableForm!: FormGroup;
  displayedColumns = [
    'srNo',
    'topic',
    'inductorBy',
    'date',
    'subTopic',
    'description',
    'feedback',
    'conductedBy',
  ];

  constructor(
    private inductionService: CounselingInductionService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.tableForm = this.fb.group({
      rows: this.fb.array([])
    });

    this.inductionId = this.route.snapshot.paramMap.get("id");

    if (this.inductionId) {
      this.loadInductionData(this.inductionId);
    }
  }

  get rows(): FormArray {
    return this.tableForm.get('rows') as FormArray;
  }

  loadInductionData(id: string) {
    this.inductionService.getById(id).pipe(takeUntil(this._destroyed$)).subscribe((doc: any) => {
      console.log("Induction Data:", doc);
      this.isLoading = false;
      if (!doc) return;

      this.counsellors.setValue(doc.inductionFor);
      this.rows.clear(); // Clear existing rows before patching

      const rows = Array.isArray(doc.rows) ? doc.rows : [];

      // Optional but recommended: Sort the data by orderNo before patching
      rows.sort((a:any, b:any) => (a.orderNo || 0) - (b.orderNo || 0));

      rows.forEach((row: any) => {
        this.rows.push(this.createRow(row));
      });

      // Crucial Step: Tell the Material Table to re-render after pushing new data
      if (this.table) {
        this.table.renderRows();
      }
    });
  }

  createRow(data: any) {
    // Safely parse the Firestore timestamp object into a JavaScript Date
    let parsedDate = '';
    if (data.date) {
      if (typeof data.date.toDate === 'function') {
        parsedDate = data.date.toDate(); // Handles Firebase SDK Timestamp
      } else if (data.date.seconds) {
        parsedDate = new Date(data.date.seconds * 1000).toISOString(); // Handles raw JSON object
      } else {
        parsedDate = data.date; // Fallback for plain strings
      }
    }

    return this.fb.group({
      orderNo: [data.orderNo || 0],
      topic: [data.topic || ''],
      inductorBy: [data.inductorBy || ''],
      date: [parsedDate],
      subTopic: [data.subTopic || ''],
      description: [data.description || ''],
      feedback: [data.feedback || ''],
      conductedBy: [data.conductedBy || '']
    });
  }

  goBack(){
    this.router.navigate(['/home/counseling/counselling-induction-list']);
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}
